<nz-layout>
  <nz-content class="centered">
    <div class="centered-box-vertical large">
      <img class="logo" src="assets/img/teamsystem.png" />
      <h1 i18n="Auth.LockIdentity.Title|title for lock identity page@@Auth.LockIdentity.Title">
        Blocca la tua identità digitale
      </h1>
      <span i18n="Auth.LockIdentity.Subtitle|subtitle for lock identity page@@Auth.LockIdentity.Subtitle">
        Inserisci i dati per richiedere il blocco della tua identità digitale.
      </span>

      <nz-spin i18n-nzTip="Auth.Generic.SpinnerText|text in spinner@@Auth.Generic.SpinnerText"
        nzTip="Invio richiesta..." [nzSpinning]="isSpinning">
        <form nz-form [formGroup]="lockIdentityForm" class="custom-form" (ngSubmit)="submitForm()">
          <nz-form-item class="login">
            <div nz-row>
              <div nz-col nzSpan="24">
                <nz-form-control [nzErrorTip]="getValidationErrorMessage(lockIdentityForm.controls.userName.errors)">
                  <nz-input-group nzPrefixIcon="user" class="login">
                    <input type="text" nz-input formControlName="userName"
                      i18n-placeholder="Auth.Generic.PlaceholderUsername|placeholder for username in form@@Auth.Generic.PlaceholderUsername"
                      placeholder="Username" />
                  </nz-input-group>
                </nz-form-control>
              </div>
              <div nz-col nzSpan="24">
                <a class="custom-form-forgot" [routerLink]="getUsernameLostLink()"
                  i18n="Auth.Login.ForgottenUsername|link to recovery username@@Auth.Login.ForgottenUsername">
                  Hai dimenticato il tuo username?
                </a>
              </div>
            </div>
          </nz-form-item>
          <nz-form-item class="login">
            <div nz-row>
              <div nz-col nzSpan="24">
                <nz-form-control [nzErrorTip]="getValidationErrorMessage(lockIdentityForm.controls.code.errors)">
                  <nz-input-group nzPrefixIcon="lock" class="login">
                    <input type="password" nz-input formControlName="code"
                      i18n-placeholder="Auth.Generic.PlaceholderEmergencyCode|placeholder for emergency code in form@@Auth.Generic.PlaceholderEmergencyCode"
                      placeholder="Codice di emergenza" />
                  </nz-input-group>
                </nz-form-control>
              </div>
              <div nz-col [nzSpan]="24">
                <a class="custom-form-forgot" [routerLink]="getCodeLostLink()"
                  i18n="Auth.PasswordLost.ForgottenEmergencyCode|link to recovery emergency code@@Auth.PasswordLost.ForgottenEmergencyCode">Hai
                  dimenticato il codice di emergenza?</a>
              </div>
            </div>
          </nz-form-item>

          <div nz-row nzAlign="middle">
            <div nz-col [nzSpan]="16">
              <a class="custom-form-forgot" [routerLink]="getAuthLink()">
                <i nz-icon nzType="arrow-left" nzTheme="outline" style="margin-right: 0.5rem;"></i>
                <ng-container
                  i18n="Auth.Generic.BackToSignInPage|label for go back to sign in page@@Auth.Generic.BackToSignInPage">
                  Torna alla pagina di accesso
                </ng-container>
              </a>
            </div>
            <div nz-col [nzSpan]="8">
              <button class="submit" nz-button nzType="primary" i18n="Generic.Send|label for send button@@Generic.Send"
                [disabled]="!lockIdentityForm.valid">INVIA</button>
            </div>
          </div>
        </form>
      </nz-spin>

    </div>
  </nz-content>
</nz-layout>
